// Sidenav menu config. Plain data — MF-safe to expose. Consumers of the
// layout expose can pass their own list (extend or trim this default) to
// PageFrame/SideNav; this host itself renders the default.
//
// Keep each route in step with the matching catalog entry's routePrefixes in
// shared/federation/remotes.config.ts — a drifting menu link 404s.
export interface MenuItem {
  label: string;
  icon: string;
  route?: string;
}

export const defaultMenuItems: MenuItem[] = [
  { label: "Home", icon: "home", route: "/" },
  { label: "Inbound Intelligence", icon: "local_shipping", route: "/ni/inbound" },
];
